<template>
  <div v-if="getChunk" v-html="getChunk" />
</template>

<script>
export default {
  name: 'CmsBlockChunk',
  props: {
    identifier: {
      type: String,
      default: null,
      required: true
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  created () {
    this.$store.dispatch('cmsBlock/single', {
      key: 'identifier',
      value: this.identifier
    });
  },
  computed: {
    getChunk () {
      if (this.identifier) {
        let __response = this.$store.getters[`cmsBlock/cmsBlockIdentifier`](
          this.identifier
        );
        if (__response) {
          let content = JSON.parse(__response.content);
          if (content === null) {
            return this.defaultValue;
          }
          if (typeof content.pl !== 'undefined') {
            return content.pl;
          }
          return content;
        } else {
          return this.defaultValue;
        }
      }
      return this.defaultValue;
    }
  }
};
</script>
